import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BASE_SITE_URL = 'https://www.thewealthyminer.com';

const CanonicalLink = () => {
  const location = useLocation();

  useEffect(() => {
    const canonicalUrl = new URL(`${location.pathname}${location.search}`, BASE_SITE_URL).toString();

    let canonicalTag = document.querySelector<HTMLLinkElement>("link[rel='canonical']");

    if (!canonicalTag) {
      canonicalTag = document.createElement('link');
      canonicalTag.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalTag);
    }

    canonicalTag.setAttribute('href', canonicalUrl);
  }, [location.pathname, location.search]);

  return null;
};

export default CanonicalLink;
